export const CART_FIELD_BY_TYPE = {
  tyre: 'tire_detail_id',
  battery: 'battery_detail_id',
  windshield: 'windshield_detail_id',
  generic: 'product_variant_id',
};

export const toIntOrNull = (value) => {
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? null : n;
};

export const getSizeLabel = (size) => {
  if (!size) return null;
  if (typeof size === 'string') return size;
  return size.name || null;
};

export const formatAttrLabel = (key = '') =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const getItemVariantType = (item) => {
  if (!item) return null;
  if (item.tire_detail_id) return 'tyre';
  if (item.battery_detail_id) return 'battery';
  if (item.windshield_detail_id) return 'windshield';
  if (item.product_variant_id) return 'generic';
  return null;
};

export const getItemVariantId = (item) => {
  const type = getItemVariantType(item);
  return type ? item[CART_FIELD_BY_TYPE[type]] : null;
};

export const buildVariantIdFields = (item = {}) => ({
  tire_detail_id: toIntOrNull(item.tire_detail_id),
  battery_detail_id: toIntOrNull(item.battery_detail_id),
  windshield_detail_id: toIntOrNull(item.windshield_detail_id),
  product_variant_id: toIntOrNull(item.product_variant_id),
});

export const isSameCartVariant = (a, b) =>
  a.productId == (b.productId ?? b.product_id) &&
  (a.tire_detail_id || null) == (b.tire_detail_id || null) &&
  (a.battery_detail_id || null) == (b.battery_detail_id || null) &&
  (a.windshield_detail_id || null) == (b.windshield_detail_id || null) &&
  (a.product_variant_id || null) == (b.product_variant_id || null);

export const findItemVariant = (item) => {
  if (!item) return null;
  const p = item.product || {};
  // Order/cart APIs return the variant directly on the item (single object),
  // older shapes put arrays inside item.product.*_variants. Support both.
  const pick = (direct, list, id) => {
    if (direct && !Array.isArray(direct)) return direct;
    const arr = Array.isArray(direct) ? direct : list;
    return arr?.find((v) => v.id == id) || null;
  };
  if (item.tire_detail_id) return pick(item.tyre_variants, p.tyre_variants, item.tire_detail_id);
  if (item.battery_detail_id) return pick(item.battery_variants, p.battery_variants, item.battery_detail_id);
  if (item.windshield_detail_id) return pick(item.windshield_variants, p.windshield_variants, item.windshield_detail_id);
  if (item.product_variant_id) return pick(item.product_variant, p.product_variants, item.product_variant_id);
  return null;
};